module.exports = __webpack_public_path__ + "scripts/outline-icons.svg?da8a235b";


//////////////////
// WEBPACK FOOTER
// ./semantic/dist/themes/default/assets/fonts/outline-icons.svg
// module id = 217
// module chunks = 1